import { render } from "./ShowingsList.vue?vue&type=template&id=07c0e856&scoped=true"
import script from "./ShowingsList.vue?vue&type=script&lang=js"
export * from "./ShowingsList.vue?vue&type=script&lang=js"

import "./ShowingsList.vue?vue&type=style&index=0&id=07c0e856&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c0e856"]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip});
